import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function invalidateFeatureValues(): RootActionTypes {
  return {
    type: ActionTypes.INVALIDATE_FEATURE_VALUES,
  };
}
